import * as React from 'react';
import { UserAuth } from '../context/AuthContext';
import UnauthorizedPage from '../pages/403';
import { Outlet } from 'react-router-dom';
import {useCan} from "../context/auth_atoms";

//Helper wrapper component used for authorization purposes

const AccessMusicAssetLabels = (): JSX.Element => {
    const can = useCan();

    const accessible = can('write', 'music::data::assetlabels');

    if (!accessible) {
        return <UnauthorizedPage message={'Sorry, you are not authorized to access this content.'} />;
    }

    return <Outlet />;
};

export default AccessMusicAssetLabels;
